import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-page-search-bar-component" }
const _hoisted_2 = { class: "search-page-search-bar" }
const _hoisted_3 = { class: "search-box" }
const _hoisted_4 = { class: "search-box-field" }
const _hoisted_5 = ["name", "placeholder"]
const _hoisted_6 = { class: "search-box-submit" }
const _hoisted_7 = {
  key: 0,
  class: "search-error"
}

import { useSearchPageStore } from "@/store/store/searchPageStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchBar',
  props: {
  pageName: {
    type: String,
    default: "",
  },
  searchBoxPlaceholderText: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const searchPageStore = useSearchPageStore();

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: `${__props.pageName}_searchbar`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchPageStore).searchPageState.search.typing) = $event)),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_unref(searchPageStore).searchPageState.search.focus = true)),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(searchPageStore).blurSearchbox && _unref(searchPageStore).blurSearchbox(...args))),
            onKeyup: [
              _cache[3] || (_cache[3] = ($event: any) => (_unref(searchPageStore).handleSearchBarKeyup($event))),
              _cache[4] || (_cache[4] = _withKeys(($event: any) => {
              _unref(searchPageStore).triggerSearch(
                props.pageName,
                _unref(searchPageStore).searchPageState.search.typing
              );
              ($event.target as HTMLInputElement).blur();
            }, ["enter"]))
            ],
            placeholder: __props.searchBoxPlaceholderText
          }, null, 40, _hoisted_5), [
            [
              _vModelText,
              _unref(searchPageStore).searchPageState.search.typing,
              void 0,
              { trim: true }
            ]
          ]),
          (
              _unref(searchPageStore).searchPageState.search.typing &&
              _unref(searchPageStore).searchPageState.search.typing.length > 0
            )
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon-cancel",
                onClick: _cache[5] || (_cache[5] = ($event: any) => {
              _unref(searchPageStore).clearSearchbox();
              _unref(searchPageStore).triggerSearch(props.pageName, null, 1);
            })
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (
              _unref(searchPageStore).triggerSearch(
                props.pageName,
                _unref(searchPageStore).searchPageState.search.typing,
                1
              )
            )),
            class: "icon-search"
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("span", null, "Search", -1)
          ]))])
        ])
      ]),
      (_unref(searchPageStore).searchPageState.search.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Search must contain at least 3 characters. "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})